import React, {Fragment} from 'react';
import {useAuth} from "./AuthProvider";
import {useLocation, Navigate, Outlet} from "react-router-dom";

const ReLoginGuard = () => {
    let {user} = useAuth();
    let location = useLocation();

    if (user && user.uid) {
        const referer = (location.state && location.state.referer) || "/";
        return <Navigate to={referer.toString()} state={{from: location}} replace={true}/>
    }
    return (
        <Fragment>
            <Outlet/>
        </Fragment>
    );
};

export default ReLoginGuard;